export function getLoggedInInterveneOrganisationScope(user) {
  const organisation = user?.profile?.organisation ?? null;
  const organisationId =
    organisation?.organisation_id ??
    user?.profile?.organisation_id ??
    user?.organisation_id ??
    '';
  return {
    isSuperAdmin: Boolean(user?.is_superuser),
    organisation,
    organisationId: organisationId ? String(organisationId) : '',
  };
}

export function lockInterveneOrganisationForUser(filters = {}, user) {
  const { isSuperAdmin, organisation, organisationId } = getLoggedInInterveneOrganisationScope(user);
  if (isSuperAdmin || !organisationId) {
    return { ...filters };
  }
  return {
    ...filters,
    organisationId,
    organisationObj: filters.organisationObj ?? organisation,
  };
}

export function defaultInterveneOrganisation(filters = {}, user) {
  if (filters.organisationId) return { ...filters };
  const { organisation, organisationId } = getLoggedInInterveneOrganisationScope(user);
  if (!organisationId) return { ...filters };
  return {
    ...filters,
    organisationId,
    organisationObj: filters.organisationObj ?? organisation,
  };
}

export function applyInterveneOrganisationScope(filters = {}, user) {
  return lockInterveneOrganisationForUser(
    defaultInterveneOrganisation(filters, user),
    user
  );
}

export function getInterveneCompanyId(filters = {}, user) {
  const scoped = applyInterveneOrganisationScope(filters, user);
  return scoped.organisationId || '';
}
